import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface Option {
  value: string;
  label: string;
}

interface AutocompleteBubbleProps {
  options: Option[];
  onSelect: (option: Option) => void;
  title?: string;
}

const OptionList = styled.ul(({ theme }) => {
  return `
    list-style: none;
    width: 100%;
    padding: 0;
    margin: 0;
    position: absolute;
    z-index: 2;
    background: white;
    top: 108%;
    left: 0;
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0px 2px 4px ${theme.new.color.neutral[7]};
  `;
});

const Title = styled.div(({ theme }) => {
  return `
        font-size: ${theme.new.type.size[16]};
        font-weight: ${theme.new.type.weight.bold};
    `;
});

const OptionItem = styled.li(({ theme }) => {
  return `
    padding: 8px 0px;
    cursor: pointer;
  
    &:hover {
      background-color: ${theme.new.color.neutral[5]};
    }
  `;
});

const AutocompleteBubble: React.FC<AutocompleteBubbleProps> = ({ options, onSelect, title }) => {
  const [isOpen, setIsOpen] = useState(true);
  const selectRef = useRef<HTMLUListElement>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleOptionSelect = (option: Option) => {
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <div>
      {isOpen && (
        <OptionList ref={selectRef}>
          {title && <Title>{title}</Title>}
          {options.map((option) => (
            <OptionItem key={option.value} onClick={() => handleOptionSelect(option)}>
              {option.label}
            </OptionItem>
          ))}
        </OptionList>
      )}
    </div>
  );
};

export default AutocompleteBubble;
